import mapFunction from './mapResources';

export default mapFunction('rewards', {
    isFetching: false,
    items: [] 
});
